export default __webpack_public_path__ + "static/media/3-column-preview-card-thumbnail.37b828e0.png";